import { render, staticRenderFns } from "./company_item_info.vue?vue&type=template&id=7dba5cab"
import script from "./company_item_info.vue?vue&type=script&lang=js"
export * from "./company_item_info.vue?vue&type=script&lang=js"
import style0 from "./company_item_info.vue?vue&type=style&index=0&id=7dba5cab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports